export const otsBody = {
  content: {
    id: null,
    title: ''
  },
  location: '',
  text: '',
  contact: ''
}
